module.exports = __webpack_public_path__ + "img/ganga.0cdd3f69.png";